import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '../FormControl/FormControl.context';
import FormLabel from '../FormLabel/FormLabel';
import FormInput from '../FormInput/FormInput';

/**
 * `TextInput` allows a user to insert text into a UI.
 * It comes with a label, input, and error message support.
 * This component is meant for implementation in a Formik form.
 */
const TextInput = ({
  id,
  name,
  validate,
  innerRef,
  label,
  className,
  ...inputProps
}) => (
  <FormControl
    id={id}
    name={name}
    validate={validate}
    containerClass={className}
  >
    <FormLabel htmlFor={id} disabled={inputProps.disabled}>
      {label}
    </FormLabel>
    <FormInput id={id} ref={innerRef} {...inputProps} />
  </FormControl>
);

TextInput.propTypes = {
  /**
   * CSS class name
   */
  className: PropTypes.string,
  /**
   * Form ID use to associate the label and input
   * Use specific naming, as a collision can cause undesirable effects.
   */
  id: PropTypes.string.isRequired,
  /**
   * Inner ref; allowing you to interact directly with the Input element.
   */
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(PropTypes.element) })
  ]),
  /**
   * Formik field name
   */
  name: PropTypes.string.isRequired,
  /**
   * Formik validation function
   */
  validate: PropTypes.func,
  /**
   * Form label
   */
  label: PropTypes.string.isRequired
};

TextInput.defaultProps = {
  className: null,
  innerRef: undefined,
  validate: undefined
};

export default TextInput;
